import React, { Component } from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

const StyledContent = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  overflow: hidden;
  overflow-y: auto;
  transform: ${props => (props.menuVisible ? 'translate3d(250px, 0, 0)' : 'none')};
  background: ${theme.B500};
  color: ${theme.font_primary};
  box-shadow: -5px 0 5px rgba(0, 0, 0, 0.3);
  -webkit-overflow-scrolling: touch;
  transition: transform 0.5s;

  & > span,
  & > span > div {
    display: flex;
    flex-flow: column;
    align-items: stretch;
    flex: 1 1 auto;
  }
`;

const MenuToggle = styled.button`
  position: absolute;
  top: 30px;
  left: 35px;
  padding: 0;
  background: none;
  border: 0;
  cursor: pointer;
  outline: none;
  z-index: 9;
  transform: ${props => (props.menuVisible ? 'rotate(180deg)' : 'none')};
  transition: all 0.5s;
  perspective: 1000;

  &:hover {
    transform: ${props => (props.menuVisible ? 'rotate(180deg) scale(0.9)' : 'scale(0.9)')};
  }

  .icon-bar {
    display: block;
    width: 30px;
    height: 5px;
    background: linear-gradient(135deg, #14acd0 0%, #13a98d 100%);
    margin-top: 5px;
    transition: all 0.5s;

    &:first-child {
      margin: 0;
    }

    &:nth-child(1),
    &:nth-child(3) {
      transform-origin: right center;
    }

    &:nth-child(1) {
      transform: ${props => (props.menuVisible ? 'scale3d(0.66, 1, 1)' : 'none')};
    }

    &:nth-child(3) {
      transform: ${props => (props.menuVisible ? 'scale3d(0.66, 1, 1)' : 'none')};
    }
  }
`;

class Content extends Component {
  toggleMenu = e => {
    e.stopPropagation();
    this.props.toggleMenu();
  };

  render() {
    return (
      <StyledContent onClick={() => this.props.toggleMenu(false)} {...this.props}>
        <MenuToggle onClick={this.toggleMenu} {...this.props}>
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </MenuToggle>
        {this.props.children}
      </StyledContent>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content.js